import { InputHTMLAttributes } from 'react';
import { classNames } from '@/utils/classNames';
import styles from './RadioButton.module.css';

type RadioButtonProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  label?: string;
};

export const RadioButton = ({ label, className, id, ...rest }: RadioButtonProps) => (
  <label className={classNames(styles.root, rest.disabled && styles.disabled, className)}>
    <input type="radio" className={styles.input} id={id} {...rest} />
    <span className={styles.visual} aria-hidden>
      <span className={styles.dot} />
    </span>
    {label && <span className={styles.label}>{label}</span>}
  </label>
);
